import { useAuthenticated } from "../../authn";

/**
 * Simple hook to check if the current user is a provisioner
 * without requiring org context
 */
export function useProvisionerCheck() {
  const authCtx = useAuthenticated();

  const isProvisioner = (): boolean => {
    return authCtx.roles.includes("AgenticProvisioner");
  };

  return { isProvisioner };
}
